/* istanbul ignore file */
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { ICaseDetail } from 'src/app/model/support/ICaseDetail';
import { SearchQueryRequest, SearchQueryResponse } from 'src/app/model/support/search-query';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private http = inject(HttpClient);
  private preInitSettingsService = inject(PreInitSettingsService);
  private resourceService = inject(ADPResourceService);

  private middlewareUrl = this.preInitSettingsService.getSettings()?.middleWare?.middlewareUrl ?? '';
  private accountPath = this.preInitSettingsService.getSettings()?.middleWare?.accountPath ?? '';
  private clientName = this.resourceService.getPortalSetting('Chat_ClientName')?.Value;

  getCaseHistory(phoneNumber: string): Observable<ICaseDetail[]> {
    const httpOptions = {
      params: new HttpParams()
        .set('phoneNumber', phoneNumber)
        .set('clientName', this.clientName)
    };

    return this.http.get<ICaseDetail[]>(`${this.middlewareUrl}${this.accountPath}casedetails`, httpOptions).pipe(
      catchError(error => {
        console.error('SupportService.getCaseHistory error:', error);
        return throwError(() => error);
      })
    );
  }

  // TODO: Replace ChatTranscript with a fully typed interface
  getChatTranscripts(phoneNumber: string): Observable<Record<string, unknown>[]> {
    const httpOptions = {
      params: new HttpParams()
        .set('phoneNumber', phoneNumber)
        .set('clientName', this.clientName)
    };

    return this.http.get<Record<string, unknown>[]>(`${this.middlewareUrl}${this.accountPath}chattranscripts`, httpOptions).pipe(
      catchError(error => {
        console.error('SupportService.getChatTranscripts error:', error);
        return throwError(() => error);
      })
    );
  }

  searchQuery(query: string, systemPrompt?: string): Observable<SearchQueryResponse> {
    const body: SearchQueryRequest = { query, mode: 'string' };
    if (systemPrompt) {
      body.systemPrompt = systemPrompt;
    }

    return this.http.post<SearchQueryResponse>(`${this.middlewareUrl}${this.accountPath}ai-search-query`, body).pipe(
      catchError(error => {
        console.error('SupportService.searchQuery error:', error);
        return throwError(() => error);
      })
    );
  }
}
